import {Container} from "./Container"

export const RouterStyles = {
    Container: Container
}